<template>
    <div class="win">
        <div class="header">
            <div class="navItem">
                <i class="iconfont icon-jianzhuanquan-"></i>
                <div class="title" v-bind:style="{ letterSpacing: language === 'en' ? '0px':''}">{{ $t('systemSetting.alarmMessage') }}</div>
                <div class="desc"></div>
            </div>
        </div>
        <div class="content" v-loading="loading" element-loading-text="Loading" element-loading-spinner="el-icon-loading" element-loading-background="rgba(22, 22, 22, 1)">
            <div class="table_box">
                <el-form @submit.native.prevent class="table_header tableSearchForm" :inline="true" size="small" label-width="80px" label-position="left">
                    <div class="btn btn_active" @click="handelAdd"><i class="el-icon-plus"></i><span>{{ $t('ems.alarm.new') }}</span></div>
                    <div class="btn btn_active" style="float:  right; width: 100px">
                        <el-button type="text" icon="el-icon-refresh" @click="search" style="width: 100%; height: 100%;line-height: 30px; border-radius: 0px; color: rgb(10, 207, 230); font-size: 16px; padding: 0 10px">{{ $t('ems.alarm.refresh') }}</el-button>
                    </div>
                    <div class="btn btn_active" @click="alarmLevelSet" style="float: right; width: 160px">
                        <i class="el-icon-s-operation"></i><span>{{ $t('systemSetting.alarmLevelSet') }}</span>
                    </div>
                </el-form>
                <el-table
                        ref="tableList"
                        :data="list"
                        style="width: 100%"
                        v-loading="listLoading"
                        border
                        size="small"
                        height="740"
                        class="BMSTable configList"
                >
                    <el-table-column width="200" :label="$t('systemSetting.groupName')" prop="groupName"></el-table-column>
                    <el-table-column :label="$t('systemSetting.groupAddress')" prop="groupAddress"></el-table-column>
                    <el-table-column width="100" :label="$t('systemSetting.isShotDown')" prop="stop">
                        <template slot-scope="scope">
                            {{ scope.row.stop == 1 ? $t('systemSetting.yes') : $t('systemSetting.no')}}
                        </template>
                    </el-table-column>
                    <el-table-column width="220" :label="$t('systemSetting.remark')" prop="remark"></el-table-column>
                    <el-table-column :label="$t('ems.alarm.operation')" align="center" :width="language === 'zh' ? 240 : 260">
                        <template slot-scope="scope">
                            <el-button @click.native.prevent="handleAlarmSet(scope.row)" type="text" size="small" icon="el-icon-s-tools">{{ $t('systemSetting.alarmSet') }}</el-button>
                            <el-button @click.native.prevent="handleConfirm(scope.row)" type="text" size="small" icon="el-icon-edit-outline">{{ $t('ems.edit') }}</el-button>
                            <el-button @click.native.prevent="handleDelete(scope.row.id)" type="text" size="small" icon="el-icon-delete">{{ $t('ems.alarm.delete') }}</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div v-if="addVisible">
                <el-dialog :title="addForm.id ?  $t('ems.edit') : $t('ems.alarm.new')" :visible.sync="addVisible" append-to-body width="600px"
                           top="200px" :close-on-click-modal="true" custom-class="dialog-custom-class">
                    <el-form @submit.native.prevent class="table_header tableSearchForm" style="width: 100%; margin-left: 60px" size="small" label-width="100px" label-position="left" :model="addForm" :rules="rules" ref="ruleForm">
                        <el-form-item :label="$t('systemSetting.groupName')" prop="groupName"><el-input v-model="addForm.groupName" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 300px"></el-input></el-form-item>
                        <el-form-item :label="$t('systemSetting.groupAddress')" prop="groupAddress"><el-input v-model="addForm.groupAddress" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 300px"></el-input></el-form-item>
                        <el-form-item :label="$t('systemSetting.isShotDown')" prop="stop">
                            <el-radio-group v-model="addForm.stop">
                                <el-radio :label="1" >{{$t('systemSetting.yes')}}</el-radio>
                                <el-radio :label="0" >{{$t('systemSetting.no')}}</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item :label="$t('systemSetting.remark')"><el-input  type="textarea" v-model="addForm.remark" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 300px" ></el-input></el-form-item>

                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button size="small" @click="addVisible = false">{{ $t('ems.strategy.cancel') }}</el-button>
                        <el-button size="small" type="primary" @click="subminAdd">{{ $t('ems.strategy.confirm') }}</el-button>
                    </div>
                </el-dialog>
            </div>

<!--            <div class="columnConfig" v-if="alarmLevelVis">-->
<!--                <alarmLevelSet ref="columnConfig"></alarmLevelSet>-->
<!--            </div>-->
            <template v-if="alarmLevelVis">
                <el-dialog :title="$t('systemSetting.alarmLevelSet')" :visible.sync="alarmLevelVis" append-to-body width="800px" :close-on-click-modal="false" custom-class="dialog-custom-class">
                    <div style="display: flex;  width: 100%">
                        <el-form @submit.native.prevent :model="dictForm"  :rules="alarmRules" ref="dictForm" size="small" label-width="80px" class="tableSearchForm" style="width: 240px; margin-left: 10px; margin-right: 20px; background: #252525; padding: 40px 40px 40px 10px">
                            <el-form-item :label="$t('systemSetting.levelName')">
                                <el-input v-model="dictForm.levelName"></el-input>
                            </el-form-item>
                            <el-form-item :label="$t('systemSetting.checkPeriod')" prop="dictKey">
                                <el-input v-model="dictForm.checkPeriod" maxlength="2"  oninput="value=value.replace(/[^0-9]/g,'')"></el-input> 1~60分钟
                            </el-form-item>
                            <div style="margin-top: 40px; text-align: right">
                                <el-button size="small" type="primary" @click="handleDictAdd" :loading="dictAddLoading">{{ $t('ems.add') }}</el-button>
                            </div>
                        </el-form>
                        <el-table :data="activeRowTagDictList" v-loading="listLoading" border size="mini" height="320" class="BMSTable tagDictList" style="width: 320px">
                            <el-table-column :label="$t('systemSetting.levelName')"  prop="levelName"></el-table-column>
                            <el-table-column :label="$t('systemSetting.checkPeriod')" prop="checkPeriod"></el-table-column>
                            <el-table-column :label="$t('ems.operate')" width="100">
                                <template slot-scope="scope">
                                    <el-button  type="text" style="border: none"  @click.native.prevent="handleDictDelete(scope.row.id)" size="small" icon="el-icon-delete">{{ $t('ems.alarm.delete') }}</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>

                    <div slot="footer" class="dialog-footer">
                        <el-button size="small" @click="alarmLevelVis = false">{{ $t('ems.strategy.cancel') }}</el-button>
                    </div>
                </el-dialog>
            </template>

            <template v-if="alarmSetWinVis">
                <el-dialog :title="$t('systemSetting.alarmSet')" :visible.sync="alarmSetWinVis" append-to-body width="1300px" :close-on-click-modal="false" custom-class="dialog-custom-class dialog-custom-class-min" top="80px">
                    <alarmMessageSet :groupId="activeRow.id"></alarmMessageSet>
                </el-dialog>
            </template>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import { getWeChatList, addWeChat, removeWeChat, getAlarmLevelList, removeAlarmLevel, submitAlarmLevel } from "@/api/spms";
    import alarmMessageSet from "./components/alarmMessageSet"
    import i18n from "@/lang";

    export default {
        name: "dataExportSys",
        components:{ alarmMessageSet },
        data(){
            return {
                loading: false,
                timer: '',
                form: {

                },
                list: [],
                activeRow: {},
                listLoading: false,
                addVisible:  false,
                addForm: {},
                rules: {
                    groupName: { required: true, message: i18n.t("systemSetting.inputTip"), trigger: 'blur' },
                    groupAddress: { required: true, message: i18n.t("systemSetting.inputTip"), trigger: 'blur' },
                },


                alarmLevelVis: false,
                alarmRules: {
                    levelName: [
                        { required: true, message: i18n.t("systemSetting.inputTip"), trigger: 'blur' },
                    ],
                    checkPeriod: [
                        { required: true, message: i18n.t("systemSetting.inputTip"), trigger: 'blur' },
                    ],
                },
                activeRowTagDictList: [],
                dictAddLoading: false,
                dictForm: {
                    stop: 0,
                },

                alarmSetWinVis: false,
            }
        },
        computed: {
            ...mapGetters(["language"]),
        },
        filters: {

        },
        created(){
            this.loadData();
        },
        methods: {
            search(){
                this.page = 1;
                this.loadData();
            },

            loadData(){
                this.listLoading = true;
                getWeChatList({}).then(res => {
                    this.listLoading = false;
                    this.list = res.data.data;
                }).catch(err => {
                    this.listLoading = false;
                    console.log(err);
                });
            },
            handleSizeChange(val) {
                this.page = 1;
                this.size = val;
                this.loadData();
            },
            handleCurrentChange(val) {
                this.page = val;
                this.loadData();
            },
            handelAdd(){
                this.addForm = { stop: 0 };
                this.addVisible = true;
            },
            handleConfirm(row){
                this.addForm = { ...row };
                this.addVisible = true;
            },
            subminAdd(){
                this.$refs["ruleForm"].validate((valid) => {
                    if (valid) {
                        this.addVisible = false;
                        const params = {...this.addForm};
                        addWeChat(params).then(() => {
                            this.$message.success(i18n.t("ems.SuccessfulOperation"));
                            this.loadData();
                        }).catch(err => {
                            console.log(err);
                            this.$message.error(i18n.t("ems.addFailedTip") + err)
                        });
                    } else {
                        return false;
                    }
                });

            },
            handleDelete(id) {
                this.$confirm(i18n.t("systemSetting.sureDeleteWeChatTip"), {
                    confirmButtonText: i18n.t("ems.strategy.confirm"),
                    cancelButtonText: i18n.t("ems.strategy.cancel"),
                    type: "warning"
                }).then(() => {
                    removeWeChat(id).then(() => {
                        this.$message.success(i18n.t("ems.strategy.DeletedSuccessfully"));
                        this.loadData();
                    }).catch(err => {
                        this.$message.error(err)
                    });
                }).then(() => {
                });
            },
            handleAlarmSet(row){
                this.activeRow = row;
                this.alarmSetWinVis = true;
            },

            alarmLevelSet(){
                getAlarmLevelList().then(res => {
                    this.activeRowTagDictList = res.data.data || [];
                    this.dictForm = { stop: 0 };
                    this.alarmLevelVis = true;
                });
            },
            handleDictAdd(){
                this.$refs['dictForm'].validate((valid) => {
                    if (valid) {
                        this.dictAddLoading = true;
                        submitAlarmLevel({ ...this.dictForm }).then(res => {
                            this.dictAddLoading = false;
                            if(res && res.data && res.data.success){
                                this.$message.success(i18n.t("ems.SuccessfulOperation"));
                                this.dictForm = { levelName: '', checkPeriod: '', stop: 0 };
                                getAlarmLevelList(this.dictForm.tagNo).then(res1 => {
                                    this.activeRowTagDictList = res1.data.data || [];
                                });
                            }else{
                                this.$message.error(i18n.t("ems.operationFailed"))
                            }
                        }).catch(err => {
                            console.log(err);
                            this.dictAddLoading = false;
                            this.$message.error(i18n.t("ems.operationFailed"))
                        })
                    } else {
                        return false;
                    }
                });
            },
            handleDictDelete(id){
                this.$confirm(i18n.t("ems.alarm.sureyouwanttodothis"), i18n.t("ems.alarm.promptTip"), {
                    confirmButtonText: i18n.t("ems.alarm.confirmTip"),
                    cancelButtonText: i18n.t("ems.alarm.cancelTip"),
                    closeOnClickModal: false,
                    type: 'warning',
                }).then(() => {
                    removeAlarmLevel(id).then(res => {
                        if (res && res.data && res.data.success) {
                            this.$message.success(i18n.t("ems.alarm.OperationSuccessfulTip"));
                            getAlarmLevelList().then(res1 => {
                                this.activeRowTagDictList = res1.data.data || [];
                                this.alarmLevelVis = true;
                            });
                        } else {
                            this.$message.success(i18n.t("ems.alarm.OperationFailedTip"));
                        }
                    }).catch(err => {
                        this.$message.error(err)
                    });
                });
            },
        },
        destroyed() {
            if(this.timer) clearInterval(this.timer);
        }
    }
</script>

<style scoped lang="scss">
    @import "@/styles/site";
    .win{
        width: 100%;
        height: 100%;
        .header{
            height: 52px;
            background-color: var(--nav_inner);
            position: relative;
            .navItem{
                height: 100%;
                color: $font_bright_blue_title;
                display: flex;
                align-items: center;
                transition: all 0.3s linear;
                i{
                    font-size: 22px;
                    margin: 3px 20px 0;
                }
                .title{
                    letter-spacing: 3px;
                    font-size: 22px;
                }
                .desc{
                    margin-left: 24px;
                    font-size: 14px;
                    color: $_128_128_128;
                }
            }
        }
        .content{
            height: calc(100% -  52px);
            padding: 0 30px;
            overflow: hidden;
            position: relative;
            .table_box{
                width: 100%;
                .table_header{
                    margin-top: 20px;
                    height: 30px;
                    margin-bottom: 20px;
                }
                .page{
                    margin-top: 20px;
                }
            }
            .columnConfig{
                position: absolute;
                left: 0;
                top: 70px;
                width: 100%;
                height: 768px;
                z-index: 1999;
            }
        }
    }
</style>
<style lang="scss">
    .configList{
        .el-table__body-wrapper::-webkit-scrollbar {
            width: 10px;
            height: 12px !important;
        }
    }
</style>